// "Cancelar esta compra?" — Esc no cardápio do BALCÃO (pedido do dono,
// 29/09/2026). Desde 30/09/2026 o NÃO vem aceso (e com o foco): Enter sem
// pensar não perde o carrinho. Tab, Shift+Tab e as setas alternam Sim/Não;
// Enter no Sim limpa o carrinho (e o cliente escolhido); Esc fecha sem
// cancelar. O mouse também funciona nos dois botões.
import { useEffect, useRef, useState } from "react";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import TeclaAtalho from "./TeclaAtalho";
import { fmt } from "../lib/helpers";

const ALTERNA = ["Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];

export default function DialogCancelarCompra({ aberto, onFechar, onConfirmar, itens, total }) {
  const [aceso, setAceso] = useState("nao");
  const naoRef = useRef(null);
  useEffect(() => { if (aberto) setAceso("nao"); }, [aberto]);
  const tecla = (e) => {
    if (ALTERNA.includes(e.key)) {
      e.preventDefault();
      setAceso((a) => (a === "sim" ? "nao" : "sim"));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (aceso === "sim") onConfirmar(); else onFechar();
    }
  };
  const botao = (qual) => `flex-1 h-14 rounded-xl font-bold text-lg transition-all flex items-center justify-center gap-2 ${aceso === qual ? "ring-4 ring-orange-500/40 " : ""}`;
  return (
    <Dialog open={aberto} onOpenChange={(v) => { if (!v) onFechar(); }}>
      <DialogContent hideClose onKeyDown={tecla} onOpenAutoFocus={(e) => { e.preventDefault(); naoRef.current?.focus(); }} data-e2e="dialog-cancelar-compra" className="sm:max-w-md bg-zinc-900 border border-zinc-700 text-zinc-100 rounded-2xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-black text-zinc-100">Cancelar esta compra?</DialogTitle>
          <DialogDescription className="text-zinc-400 text-base">
            {itens} {itens === 1 ? "item" : "itens"} · R$ {fmt(total)} — o carrinho e o cliente escolhido serão limpos.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 mt-2">
          <button type="button" onClick={onConfirmar} onMouseEnter={() => setAceso("sim")} data-e2e="cancelar-compra-sim" data-aceso={aceso === "sim" ? "1" : "0"}
            className={`${botao("sim")} bg-red-600 hover:bg-red-700 text-white`}>Sim, cancelar</button>
          <button type="button" ref={naoRef} onClick={onFechar} onMouseEnter={() => setAceso("nao")} data-e2e="cancelar-compra-nao" data-aceso={aceso === "nao" ? "1" : "0"}
            className={`${botao("nao")} bg-zinc-800 hover:bg-zinc-700 text-zinc-200`}>Não, continuar</button>
        </div>
        <p className="text-xs text-zinc-500 flex items-center justify-center gap-2 mt-1">
          <TeclaAtalho>Tab</TeclaAtalho> ou <TeclaAtalho>← →</TeclaAtalho> alterna · <TeclaAtalho>Enter</TeclaAtalho> confirma · <TeclaAtalho>Esc</TeclaAtalho> volta
        </p>
      </DialogContent>
    </Dialog>
  );
}
